import './common/styles/utilities.scss';
import { observer } from 'mobx-react-lite';
import smoothscroll from 'smoothscroll-polyfill';
import React, { useEffect, useMemo } from 'react';
import * as system from 'reakit-system-bootstrap';
import { Provider as ReakitProvider } from 'reakit/Provider';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import theme from '@/common/styles/theme';
import {
    BroadbandPortal,
    CartPortal,
    DAOFormPortal,
    FrontPageCTAButtonsPortal,
    GlobalCartIconPortal,
    GlobalCartIconPortalMobile,
    MobileRaffleLinkPortal,
    TVPortal,
} from './portals';

import GlobalCartIcon from '@/modules/GlobalCartIcon';
import RaffleButton from '@/modules/MobileRaffleLink';
import Cart from '@/modules/Cart';
import TV from '@/modules/TV';
import Broadband from '@/modules/Broadband';
import DAOForm from '@/modules/DAOForm';

import ModalCloseButtonIcon from '@/common/components/Modal/modal-close-button.png';
import LocationPin from '@/common/components/AddressLookup/location-pin.svg';
import ArrowRight from '@/common/components/AddressLookup/arrow-right.svg';
import Search from '@/common/components/AddressLookup/search.svg';
import { withProfiler } from '@sentry/react';
import FrontpageCTAButtons from '@/common/components/FrontpageCTAButtons';
import { useWindowSize } from '@/common/utilities/helpers';
import { useMenu } from 'reakit';

smoothscroll.polyfill();

const HeaderHackStyles = createGlobalStyle`
  .dialog-off-canvas-main-canvas {
    .header,
    .offscreen-navigation,
    .offscreen-navigation-backdrop {
      z-index: 13; // Necessary to overlap header banners. This is a very temporary fix!!!
    }
  }
`;

const HeaderHack = () => {
    const { width } = useWindowSize();

    const text = useMemo(() => {
        if (width < 1024) {
            return 'Stofa skifter navn til Norlys den 12. september. <a style="color: inherit; text-decoration: underline" href="/norlys">Læs mere</a>';
        }
        return 'Stofa skifter navn til Norlys den 12. september. Vores produkter, priser og services er de samme som før. <a style="color: inherit; text-decoration: underline" href="/norlys">Læs mere</a>';
    }, [width]);

    useEffect(() => {
        const endorsementBar = document.querySelector(
            'div#block-stofa2020-endorsementblock'
        );
        if (endorsementBar) {
            endorsementBar.innerHTML = `
                <div style="display: flex;align-items: center;justify-content: center;background-color: #ffdee5; line-height: 32px;padding: .5rem">
                    <span style="color: #1E1E1C;font-size: 12px;margin-right: 11px;line-height: 1">
                        ${text}
                    </span>
                </div>
            `;
        }
    }, [text]);

    return <HeaderHackStyles />;
};

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <ReakitProvider unstable_system={system}>
                <FrontPageCTAButtonsPortal>
                    <FrontpageCTAButtons />
                </FrontPageCTAButtonsPortal>
                <GlobalCartIconPortal>
                    <GlobalCartIcon />
                </GlobalCartIconPortal>
                <GlobalCartIconPortalMobile>
                    <GlobalCartIcon />
                </GlobalCartIconPortalMobile>
                <MobileRaffleLinkPortal>
                    <RaffleButton />
                </MobileRaffleLinkPortal>
                <CartPortal>
                    <Cart />
                </CartPortal>
                <BroadbandPortal>
                    <Broadband />
                </BroadbandPortal>
                <TVPortal>
                    <TV />
                </TVPortal>
                <DAOFormPortal>
                    <DAOForm />
                </DAOFormPortal>
                {/*
                Todo:
                Nasty hack!!!
                Preload icons because some bug doesn't allow ts-imports of assets in lazy loaded modules
                – unless they're already cached, apparently
                */}
                <div style={{ display: 'none' }}>
                    {ModalCloseButtonIcon}
                    {LocationPin}
                    {ArrowRight}
                    {Search}
                </div>

                <HeaderHack />
            </ReakitProvider>
        </ThemeProvider>
    );
};

export default withProfiler(observer(App));
